import React from "react"

import PropTypes from "prop-types"

import * as styles from "./wrapper.module.scss"

const Wrapper = ({
  children,
  container,
  flex,
  className,
  spacer,
  newsletter,
}) => (
  <div
    className={`${className} ${styles.wrapper} ${
      container ? styles.wrapper__container : ""
    } ${flex ? styles[`wrapper__flex${flex}`] : ""}  ${
      spacer ? styles.wrapper__spacer : ""
    }  ${newsletter ? styles.wrapper__newsletter : ""}`}
  >
    {children}
  </div>
)

export default Wrapper

Wrapper.propTypes = {
  children: PropTypes.node,
  container: PropTypes.bool,
  flex: PropTypes.string,
  className: PropTypes.string,
  spacer: PropTypes.bool,
  newsletter: PropTypes.bool,
}

Wrapper.defaultProps = {
  children: null,
  container: false,
  flex: null,
  className: "",
  spacer: false,
  newsletter: false,
}
